<template>
  <div>
    <PageHeader
      :navigation="navigation"
      :alternate-languages="languageMenuLinks"
      :vertical="page.context.vertical"
    />
    <PageBody v-if="landingContent" :body="landingContent" :page="page" no-hero />
    <TransferComparison
      class="container mb-20"
      :corridor="corridor"
      :metadata="page"
      :historical-data="historicalData"
      landing-mode
    />
    <PageBody :body="body" :page="page" no-hero />
    <LazyPageFooter v-if="footer" :footer="footer" />
  </div>
</template>

<script lang="ts" setup>
import loadPageData from './async-data'

const {
  navigation,
  footer,
  body,
  landingContent,
  page,
  corridor,
  alternateUrls,
  canonicalUrls,
  historicalData,
} = await loadPageData()

const pageMeta = computed(() => ({ ...page, alternateLanguages: canonicalUrls }))
usePageMeta(pageMeta.value)

// Links to the same page with params in different languages
const languageMenuLinks = computed(() => {
  return alternateUrls.map(({ language, slug }) => {
    return { language, slug: join(slug, String(corridor.amount ?? '')) }
  })
})
</script>
